export function QFieldDefPair(newFieldDef, oldFieldDef, userAdded) {
  this.fNewDef = newFieldDef;
  this.fPriorDef = oldFieldDef;
  this.fUserAdded = userAdded;
}
